import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16,
      r: 16,
      fill: "#5381C2"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16,
      r: 9.333,
      fill: "#F2C95E"
    }), /*#__PURE__*/_jsx("circle", {
      cx: 16,
      cy: 16,
      r: 4,
      fill: "#C9493B"
    })]
  }));
};
export default SvgComponent;